import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PanelModule } from 'primeng/panel';
import { RewardsThisPeriodWidget } from '../../models/loyalty-dashboard.model';

@Component({
  selector: 'app-rewards-this-period-widget',
  standalone: true,
  imports: [CommonModule, RouterModule, PanelModule],
  template: `
    <p-panel header="Rewards this period">
      <div class="rewards-period" *ngIf="data as widget; else noData">
        <dl class="rewards-period__stats">
          <div class="rewards-period__row">
            <dt class="rewards-period__label">Points earned</dt>
            <dd class="rewards-period__value">{{ widget.pointsEarned | number }}</dd>
          </div>
          <div class="rewards-period__row">
            <dt class="rewards-period__label">Rewards redeemed</dt>
            <dd class="rewards-period__value">{{ widget.rewardsRedeemed | number }}</dd>
          </div>
          <div class="rewards-period__row">
            <dt class="rewards-period__label">Cost of rewards</dt>
            <dd class="rewards-period__value">{{ widget.costOfRewards | currency : 'USD' : 'symbol' : '1.0-0' }}</dd>
          </div>
          <div class="rewards-period__row">
            <dt class="rewards-period__label">Most redeemed</dt>
            <dd class="rewards-period__value">{{ widget.mostRedeemed || '—' }}</dd>
          </div>
        </dl>

        <p class="rewards-period__note" *ngIf="widget.returnPerDollar">
          Every <strong>$1</strong> in rewards returned about
          <strong>{{ widget.returnPerDollar | currency : 'USD' : 'symbol' : '1.0-0' }}</strong> in added sales.
        </p>

        <a class="rewards-period__link" [routerLink]="['../admin/loyalty-program']">Manage rewards</a>
      </div>
      <ng-template #noData>
        <p class="rewards-period__empty">No data available.</p>
      </ng-template>
    </p-panel>
  `,
  styles: [
    `
      .rewards-period {
        display: flex;
        flex-direction: column;
        gap: 1.1rem;
      }
      .rewards-period__stats {
        display: flex;
        flex-direction: column;
        gap: 0.9rem;
        margin: 0;
      }
      .rewards-period__row {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        gap: 1rem;
      }
      .rewards-period__label {
        font-size: 1rem;
      }
      .rewards-period__value {
        margin: 0;
        font-weight: 700;
        white-space: nowrap;
      }
      .rewards-period__note {
        margin: 0;
        padding-top: 1.1rem;
        border-top: 1px solid var(--surface-200, #e9ecef);
        font-size: 0.9rem;
        opacity: 0.7;
      }
      .rewards-period__link {
        font-weight: 700;
        text-decoration: underline;
        color: var(--primary-color, #2563eb);
        cursor: pointer;
      }
      .rewards-period__empty {
        opacity: 0.6;
      }
    `,
  ],
})
export class RewardsThisPeriodWidgetComponent {
  @Input() data: RewardsThisPeriodWidget | null = null;
}
